<template>
  <div class="pollutionPrediction" ref="pollutionPrediction">
    <div class="predictBar">
      <div class="predictBar-title">
        {{ "预测超标点位" + globalpredicts.length + "个" }}
      </div>
      <div class="predictBar-container">
        <!--div class="slide-title">
          <span v-for="(item, i) in predictList" v-bind:key="i">{{ item.time }}</span>
        </div-->
        <div class="slide-container" ref="jsSlideList">
          <VueScroll :data_scroll="globalpredicts" @renderPlay="renderPlay"></VueScroll>

          <!--css设置时，注意高度是显示多少个item,如：item的高度是30px，显示3个，高度则是 3*30 = 90px -->

          <!--strong>{{ "预测时间：" + item.time }}</strong-->

          <!-- eslint-disable-next-line vue/require-v-for-key -->
          <!-- <vue-seamless-scroll
            :data="globalpredicts"
            :class-option="optionHover"
            class="seamless-warp"
            v-if="globalpredicts.length > 0"
          >
            <ul class="slide-list js-slide-list">
              <li
                v-for="(item, i) in globalpredicts"
                v-bind:key="i"
                class="slideItem"
                @click="renderPlay(item)"
              >
                <p class="content">{{ "预测点位：" + item.deviceName }}</p>
                <strong class="title">{{
                  "预测浓度：" + item.value + "μg/m³"
                }}</strong>
                <p class="content">
                  {{ "预测时间：" + getTimeFormat(item.time) }}
                </p>
              </li>
            </ul>
          </vue-seamless-scroll> -->
        </div>
      </div>
    </div>
    <div class="decisionBar">
      <div class="decisionBar-title">
        {{ "生成辅助决策" + decisionList.length + "个" }}
      </div>
      <div class="decisionBar-container">
        <!--div class="slide-title">
          <span v-for="(item, i) in predictList" v-bind:key="i">{{ item.time }}</span>
        </div-->
        <div class="slide-container" ref="jsDecisionSlideList">
          <!--css设置时，注意高度是显示多少个item,如：item的高度是30px，显示3个，高度则是 3*30 = 90px -->
          <vue-seamless-scroll
            :data="decisionList"
            :class-option="optionHover1"
            class="seamless-warp2"
            v-if="decisionList.length > 0"
          >
            <ul class="slide-list js-slide-list">
              <!-- eslint-disable-next-line vue/require-v-for-key -->
              <li v-for="(item, i) in decisionList" v-bind:key="i" class="slideItem">
                <!--strong>{{ "预测时间：" + item.time }}</strong-->
                <span class="red">
                  {{
                    item.deviceName + "可能在 " + getTimeFormat(item.time) + " 出现污染"
                  }}
                </span>
                <br />
                <span class="grey">预测TSP浓度：</span>
                <span class="green">{{ item.value + "μg/m³" }}</span>
                <p class="content">
                  <span class="grey">预测原因：</span>
                  <span class="green">
                    {{
                      "上游排放源 " +
                      item.upperName +
                      " 在" +
                      getTimeFormat(item.upperTime) +
                      " 出现污染，预测" +
                      getTimeFormat(item.time) +
                      item.deviceName +
                      "会出现污染"
                    }}
                  </span>
                </p>
                <p class="content">
                  <span class="grey">指导意见：</span>
                  <span class="green">{{
                    "请预先对" + item.deviceName + "进行加湿、清洁、防护等治理工作"
                  }}</span>
                </p>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>

    <div class="processComponent">
      <div class="alarmBar">
        <div class="alarmIcon">
          <img class="alarmTag" src="./img/red.png" />
          <img class="alarmImg" src="./img/4.png" />
        </div>
        <div class="alarmContent">实时告警</div>
      </div>
      <div class="alarmBar" style="top: 180px">
        <div class="predictIcon"></div>
        <div class="alarmContent">污染预测</div>
      </div>
      <div class="algorithmBar">
        <el-switch
          v-model="algorithmType"
          size="large"
          class="mb-2"
          :active-text="algorithmFst"
          :inactive-text="algorithmSec"
          active-color="#13ce66"
          inactive-color="#409eff"
        />
      </div>
      <div class="entitylayers" v-if="globalpredicts.length > slicenum">
        <div class="layer_title">批次切换</div>
        <div class="layercontainer">
          <span
            :class="currentlayerIndex == index ? 'data_list_active' : 'data_list'"
            v-for="(item, index) in entitylayers"
            :key="index"
            @click="changePoints(item, index)"
          ></span>
        </div>
      </div>
      <div class="everyComponent">
        <ul :class="{ noArcgis: !isArcgis }" v-if="cachePointList.length > 0">
          <template v-for="(item, i) in cachePointList">
            <li
              v-show="true"
              :id="'playPos-' + i"
              v-if="
                qdWinPos[i + cacheList.length] &&
                qdWinPos[i + cacheList.length][0] &&
                qdWinPos[i + cacheList.length][3]
              "
              :key="i"
              class="ComponentTip_"
              :style="{
                left: qdWinPos[i + cacheList.length][0] / prew - 29 + 'px',
                bottom: qdWinPos[i + cacheList.length][3] / prew - 32 + 'px',
              }"
            >
              <div class="upperName">
                {{ item.data.upperName + " ( " + item.data.upperValue + "μg/m³ )" }}
              </div>
              <div v-if="false" class="upperValue">
                {{ item.data.upperValue + "μg/m³" }}
              </div>
              <div v-if="!item.type">
                <img class="red" src="./img/red.png" />
              </div>
              <div v-else-if="item.type">
                <img class="green" src="./img/green.png" />
              </div>
            </li>
          </template>
        </ul>
        <ul v-if="cacheList.length > 0">
          <template v-for="(item, i) in cacheList">
            <li
              :id="'playTip-' + i"
              v-if="qdWinPos[i] && qdWinPos[i][0] && qdWinPos[i][3]"
              :key="i"
              class="ComponentTip"
              :style="{
                left: qdWinPos[i][0] / prew - 255 + 'px',
                bottom: qdWinPos[i][3] / prew - 152 + 'px',
              }"
            >
              <div class="warn_block">
                <img :class="{ img2: true, noArcgis: !isArcgis }" src="./img/4.png" alt />
              </div>
            </li>
          </template>
        </ul>
        <ul v-if="dustList.length > 0">
          <template v-for="(item, i) in dustList" :key="i">
            <li
              :id="'dustTip-' + i"
              @mouseover="
                () => {
                  showDustTip(this);
                }
              "
              class="DustTip"
              :style="{
                left:
                  qdWinPos[i + cacheList.length + cachePointList.length][0] / prew -
                  25 +
                  'px',
                bottom:
                  qdWinPos[i + cacheList.length + cachePointList.length][3] / prew -
                  25 +
                  'px',
              }"
            >
              <div class="trace_source" ref="traceSource">
                <!-- <div class="dustPredict-load-brief" v-if="item.data.load">
                  <span class="chart-icon">
                    {{ "负载率: " + item.data.load + "%" }}
                  </span>
                </div> -->
                <div class="dustPredict-materialUse-brief" v-if="item.data.materialUse">
                  <!-- <span class="chart-icon">
                    {{ "物料使用: " + item.data.materialUse }}
                  </span> -->
                </div>
                <div class="dustPredict-brief">
                  {{
                    item.data.type == "predict"
                      ? item.data.value + "μg/m³"
                      : item.data.changeValue + "μg/m³"
                  }}
                </div>
                <div
                  :class="{
                    dustReason: true,
                    dustTransition: item.data.type == 'predict' ? true : false,
                    dustPredictTransition: item.data.type == 'predict' ? false : true,
                    dustReasonBlack: false,
                    dustPredict:
                      item.data.type == 'predict' && algorithmType ? true : false,
                    algorithmType:
                      item.data.type == 'predict' && !algorithmType ? true : false,
                  }"
                >
                  <div class="dustReasonInner">
                    <template v-if="item.data.type == 'predict'">
                      <div class="dustReasonTitle">污染预测</div>
                      <div>
                        <span class="grey">预测点位：</span>
                        <span class="green">{{ item.data.deviceName }}</span>
                      </div>
                      <div>
                        <span class="grey">预测浓度：</span>
                        <span class="green">{{ item.data.value + "μg/m³" }}</span>
                      </div>
                      <div>
                        <span class="grey">预测时间：</span>
                        <span class="green">{{ getTimeFormat(item.data.time) }}</span>
                      </div>
                      <div v-if="!algorithmType">
                        <span class="grey">负载率：</span>
                        <span style="margin-left: 20px" class="green">{{
                          item.data.load + "%"
                        }}</span>
                      </div>
                      <!--  //"kg" -->
                      <div v-if="!algorithmType">
                        <span class="grey">物料使用：</span>
                        <span class="green">{{ item.data.materialUse }}</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="dustReasonTitle">辅助决策</div>
                      <div class="mb-10 red">
                        {{
                          item.data.deviceName +
                          "可能在 " +
                          getTimeFormat(item.data.time) +
                          " 出现污染"
                        }}
                      </div>
                      <div class="mb-10">
                        <span class="grey">预测TSP浓度：</span>
                        <span class="green">{{ item.data.value + "μg/m³" }}</span>
                      </div>
                      <div class="mb-10">
                        <span class="grey">预测原因：</span>
                        <span class="green">
                          {{
                            "上游排放源 " +
                            item.data.upperName +
                            " 在" +
                            getTimeFormat(item.data.upperTime) +
                            " 出现污染，预测" +
                            getTimeFormat(item.data.time) +
                            item.data.deviceName +
                            "会出现污染"
                          }}
                        </span>
                      </div>
                      <div class="mb-10">
                        <span class="grey">指导意见：</span>
                        <span class="green">{{
                          "请预先对" +
                          item.data.deviceName +
                          "进行加湿、清洁、防护等治理工作"
                        }}</span>
                      </div>
                    </template>
                  </div>
                </div>
                <img
                  src="./img/dust.png"
                  :id="item.data.deviceNo + '_' + item.data.upperDeviceNo"
                  :class="{
                    dustRotate: item.data.type == 'predict' ? true : false,
                    dustRotate_: item.data.type == 'predict' ? false : true,
                    dustAnimate: item.data.type == 'predict' ? true : false,
                    dustAnimate_: item.data.type == 'predict' ? false : true,
                  }"
                />
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

const slicenum = 10;
const timelong_getpredict = 5 * 60;
const Currentlayertimer_long = 20;
import {
  ref,
  toRefs,
  reactive,
  getCurrentInstance,
  watch,
  onBeforeUnmount,
  onMounted,
  computed,
} from "vue";

import { useStore } from "vuex";
import VueScroll from "./VueScroll.vue";
export default {
  name: "pollutionPrediction",
  components: { VueScroll },
  props: {
    matrix: {
      type: String,
      default: "2*3",
    },
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    console.log(props);
    let globalpredicts = reactive([]);
    /**获取props的值*/
    const { matrix, x, y } = toRefs(props);

    /**获取当前组件实例*/
    const { proxy } = getCurrentInstance();
    const ctx = proxy;
    /***/

    let predictAnimate = null;
    let decisionAnimate = null;

    const customerId = ref(ctx.$store.state.customerId);
    const isArcgis = ref(false);
    isArcgis.value = bmeConfig.mapType === "unity3D" ? false : true;
    const cachePointList = reactive([]);
    const cacheList = reactive([]);
    const dustList = reactive([]);
    const qdWinPos = reactive([]);
    let currentODlineArr = [];
    const prew = ctx.$store.state.scaleValue;
    const drawRect = ref(50);
    drawRect.value = bmeConfig.drawRect ? bmeConfig.drawRect : 50;

    const ajaxInterVal = ref(null);

    const algorithmType = ref(true);
    const algorithmFst = ref("TSP污染预测");
    const algorithmSec = ref("工艺、负荷、物料污染预测");

    const entitylayers = ref([]);
    const predictListlayer = ref([]);

    const predictList = reactive([]);
    const decisionList = reactive([]);

    /**青岛特钢经纬度 */
    const flyTimer = ref(null);
    const initLayerTimer = ref(null);
    const drawScenceTimer = ref(null);

    const lastClickPoint = ref(null);
    const currentlayerIndex = ref(0);

    const timer_predicts = ref(null);


    const store = useStore();
    console.log(store);
    const threshold = ref(bmeConfig.threshold ? bmeConfig.threshold : "");
    const upperthreshold = ref(bmeConfig.upperthreshold ? bmeConfig.upperthreshold : "");

    const threshold_ = ref(bmeConfig.threshold ? bmeConfig.threshold : "");
    const upperthreshold_ = ref(bmeConfig.upperthreshold ? bmeConfig.upperthreshold : "");

    

    const clearObj = (obj) => {
      Object.keys(obj).map((key) => {
        delete obj[key];
      });
    };

    function drawScenceLayer() {
      if (
        window.g_bme3dManager?.earth?.sceneTree?.$refs?.qdPredict &&
        window.g_bme3dManager?.earth?.sceneTree?.$refs?.qdDecision
      ) {
        ajaxInterFunc();
      } else {
        if (drawScenceTimer.value) {
          clearTimeout(drawScenceTimer.value);
        }
        drawScenceTimer.value = setTimeout(() => {
          drawScenceLayer();
        }, 1000);
      }
    }

    function initLayer() {
      if (window?.window.g_bme3dManager?.earth?.sceneTree) {
        let json1 = {
          title: "青岛蒙层1",
          ref: "qdDecision",
          children: [],
        };
        window.g_bme3dManager.earth.sceneTree.root.children.push(json1);

        let json2 = {
          title: "青岛蒙层2",
          ref: "qdPredict",
          children: [],
        };
        window.g_bme3dManager.earth.sceneTree.root.children.push(json2);

        drawScenceLayer();
      } else {
        if (initLayerTimer.value) {
          clearTimeout(initLayerTimer.value);
        }
        initLayerTimer.value = setTimeout(() => {
          initLayer();
        }, 1000);
      }
    }

    watch(
      algorithmType,
      (newValue, oldValue) => {
        lastClickPoint.value = null;
        ajaxInterFunc();
      },
      { deep: true }
    );

    
    watch(
      () => store.state.threshold,
      (newValue, oldValue) => {
        lastClickPoint.value = null;
        threshold.value = Number(newValue);
        upperthreshold.value = Number(newValue);
        ajaxInterFunc();
      },
      { deep: true, immediate: true }
    );

    
    watch(
      () => store.state.threshold_,
      (newValue, oldValue) => {
        lastClickPoint.value = null;
        threshold_.value = Number(newValue).toFixed(2);
        upperthreshold_.value = Number(newValue).toFixed(2);
        ajaxInterFunc();
      },
      { deep: true, immediate: true }
    );

    function flyToQD(lng, lat, isDetail) {
      if(!lng || !lat){
        if(this.customerId == 37){
          lng = 119.720057
          lat = 35.630189
        }else if(this.customerId == 36){
          lng = 110.579804
          lat = 35.618180
        }
      }
      // const lng = 119.720057;
      // const lat = 35.630189;
      const altitude = bmeConfig.altitude;
      const flyAltitude = altitude < 350 ? 350 : altitude;
      if (lng && lat) {
        // by 刘阳洋 有些设备无坐标
        let flyArg = window.window.g_bme3dManager
          ? JSON.parse(window.g_bme3dManager.earth.camera.toAllJSONStr())
          : {};

        let earth = window.window.g_bme3dManager
          ? window.window.g_bme3dManager.earth
          : "";

        if (earth.camera && earth.camera.flyTo) {
          earth.camera &&
            earth.camera.flyTo(
              [(lng * Math.PI) / 180.0, (lat * Math.PI) / 180.0, altitude + 50],
              flyAltitude + isDetail ? 1000 : 2500,
              flyArg.rotation,
              0.5
            );
        } else {
          if (flyTimer.value) {
            clearTimeout(flyTimer.value);
          }
          flyTimer.value = setTimeout(() => {
            flyToQD(lng, lat);
          }, 1000);
        }
      } else {
        if (flyTimer.value) {
          clearTimeout(flyTimer.value);
        }
        flyTimer.value = setTimeout(() => {
          flyToQD(lng, lat);
        }, 1000);
      }
    }
    /** */
    
    watch(currentlayerIndex, (newvalue, oldvalue) => {
      if (entitylayers.value.length > 1) {
        if (entitylayers.value[newvalue]) {
          predictList.length = 0;
          let start = entitylayers.value[newvalue].value[0];
          let end = entitylayers.value[newvalue].value[1];
          Object.assign(predictList, globalpredicts.slice(start, end));
          renderDecision("predict");
          turnaroundPages(Currentlayertimer_long);
        } else {
          currentlayerIndex.value = 0;
        }
      }
    });
    function ajaxInterFunc() {
      currentlayerIndex.value = 0;
      getPredictList();
      getDecisionList();
      if (ajaxInterVal.value) {
        clearTimeout(ajaxInterVal.value);
      }
      ajaxInterVal.value = setTimeout(() => {
        ajaxInterFunc();
      }, timelong_getpredict * 1000);
    }

    /**青岛特钢区域 */
    function uuid() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    }
    function createPredictLayers(lat, lng, name, numbr) {
      let key1Ref = numbr,
        key1Name = name;
      let pos1List = [
        [
          ((lng - 0.0006) * Math.PI) / 180,
          ((lat - 0.0003) * Math.PI) / 180,
          drawRect.value,
        ],
        [
          ((lng - 0.0006) * Math.PI) / 180,
          ((lat + 0.0003) * Math.PI) / 180,
          drawRect.value,
        ],
        [
          ((lng + 0.0006) * Math.PI) / 180,
          ((lat + 0.0003) * Math.PI) / 180,
          drawRect.value,
        ],
        [
          ((lng + 0.0006) * Math.PI) / 180,
          ((lat - 0.0003) * Math.PI) / 180,
          drawRect.value,
        ],
      ];
      let json = {
        ref: key1Ref,
        czmObject: {
          xbsjType: "GeoPolygon",
          enabled: true,
          xbsjGuid: "a7a97abc-455e-4f3f-a54a-d6efb5c220a4",
          name: key1Name,
          positions: pos1List,
          height: 0,
          extrudedHeight: null,
          show: true,
          outline: {},
          ground: true,
        },
      };

      let currentBuild = window.g_bme3dManager.earth.sceneTree.$refs[key1Ref];
      if (!currentBuild) {
        window.g_bme3dManager?.earth?.sceneTree?.$refs?.qdPredict?.children.push(json);
        currentBuild = window.g_bme3dManager.earth.sceneTree.$refs[key1Ref];
        if (currentBuild) {
          currentBuild.czmObject.color = bmeConfig.bg_mark_color.markColor.online;
          currentBuild.czmObject.outline.color =
            bmeConfig.bg_mark_color.markOutColor.online;
        }
      }
    }

    function createDecisionLayers(lat, lng, name, numbr, valid) {
      let key1Ref = numbr,
        key1Name = name;
      let pos1List = [
        [
          ((lng - 0.0006) * Math.PI) / 180,
          ((lat - 0.0003) * Math.PI) / 180,
          drawRect.value,
        ],
        [
          ((lng - 0.0006) * Math.PI) / 180,
          ((lat + 0.0003) * Math.PI) / 180,
          drawRect.value,
        ],
        [
          ((lng + 0.0006) * Math.PI) / 180,
          ((lat + 0.0003) * Math.PI) / 180,
          drawRect.value,
        ],
        [
          ((lng + 0.0006) * Math.PI) / 180,
          ((lat - 0.0003) * Math.PI) / 180,
          drawRect.value,
        ],
      ];

      let isClick = false;
      if (lastClickPoint.value == key1Ref) {
        isClick = true;
      }
      let json = {
        ref: key1Ref,
        czmObject: {
          xbsjType: "GeoPolygon",
          enabled: valid ? true : false,
          xbsjGuid: "a7a97abc-455e-4f3f-a54a-d6efb5c220a4",
          name: key1Name,
          positions: pos1List,
          height: 0,
          extrudedHeight: null,
          show: valid ? true : false,
          outline: {},
          ground: true,
        },
      };

      let currentBuild = window.g_bme3dManager.earth.sceneTree.$refs[key1Ref];
      if (!currentBuild) {
        window.g_bme3dManager?.earth?.sceneTree?.$refs?.qdDecision?.children.push(json);
        currentBuild = window.g_bme3dManager.earth.sceneTree.$refs[key1Ref];
        if (currentBuild) {
          if (!isClick) {
            currentBuild.czmObject.color = bmeConfig.bg_mark_color.markColor.online;
            currentBuild.czmObject.outline.color =
              bmeConfig.bg_mark_color.markOutColor.online;
          } else {
            currentBuild.czmObject.color = bmeConfig.bg_mark_color.markColor.outline;
            currentBuild.czmObject.outline.color =
              bmeConfig.bg_mark_color.markOutColor.outline;
          }
        }
      }
    }

    

    function changeDecisionLayer(name, numbr) {
      let key1Ref = numbr,
        key1Name = name;

      if (lastClickPoint.value) {
        let lastKey1Ref = lastClickPoint.value;
        let lastBuild = window.g_bme3dManager.earth.sceneTree.$refs[lastKey1Ref];
        if (lastBuild) {
          lastBuild.czmObject.color = bmeConfig.bg_mark_color.markColor.online;
          lastBuild.czmObject.outline.color = bmeConfig.bg_mark_color.markOutColor.online;
        }
      }
      lastClickPoint.value = key1Ref;

      let currentBuild = window.g_bme3dManager.earth.sceneTree.$refs[key1Ref];
      if (currentBuild) {
        currentBuild.czmObject.color = bmeConfig.bg_mark_color.markColor.outline;
        currentBuild.czmObject.outline.color =
          bmeConfig.bg_mark_color.markOutColor.outline;
      }
    }

    function dealODlineData(key1Obj, keyList) {
      let ODlineData = {
        current: {},
        next: [],
      };
      ODlineData.current = {
        longitude: key1Obj.lng,
        latitude: key1Obj.lat,
      };
      ODlineData.next = [];
      keyList.forEach((item) => {
        ODlineData.next.push({
          longitude: item.lng,
          latitude: item.lat,
        });
      });
      /*if (!$.isEmptyObject(currentODlineArr)) {
        delLines();
      }*/
      let currentODlineObj = createODLines(ODlineData);
      currentODlineArr.push(currentODlineObj);
    }

    function createODLines(ODlineData) {
      let odlineDealData = [];
      if (
        !ODlineData?.current?.longitude ||
        !ODlineData?.current?.latitude ||
        !ODlineData?.next?.length
      )
        return;
      ODlineData.next.forEach((item) => {
        odlineDealData.push([
          [(item.longitude * Math.PI) / 180, (item.latitude * Math.PI) / 180, 0],
          [
            (ODlineData.current.longitude * Math.PI) / 180,
            (ODlineData.current.latitude * Math.PI) / 180,
            0,
          ],
        ]);
      });
      // console.log("odlineDealData", odlineDealData);
      let earth = window.g_bme3dManager.earth;
      const odlines = new XE.Obj.ODLines(earth);
      odlines.color = [1, 1, 1, 1];

      var busLines = [];

      var p = odlineDealData;

      var positionsCollection = p.map((e) => {
        const toDegree = 180.0 / Math.PI;
        // Cesium.xbsjCreateTransmitPolyline 根据 首末端点生成弧线，
        // 参数有：
        // startPosition, 端点1
        // endPosition, 端点2
        // minDistance, 计算出的线段的最小间隔距离
        // heightRatio=1.0 弧线高度抬升程度，值越大，抬高得越明显
        // 返回值是cartesian类型的坐标数组
        const cartesians = Cesium.xbsjCreateTransmitPolyline(e[0], e[1], 50.0, 5.0);
        const poss = cartesians.map((ee) => {
          const carto = Cesium.Cartographic.fromCartesian(ee);
          return [carto.longitude, carto.latitude, carto.height];
        });

        return poss;
      });
      positionsCollection.push(...positionsCollection);
      positionsCollection.push(...positionsCollection);

      let timeDuration = 10.0;
      let moveBaseDuration = 4.0;

      busLines = positionsCollection.map((e) => {
        return {
          positions: e,
          color: [0.5, 0.8, 1.0, 5.0],
          width: 5.0,
          startTime: timeDuration * Math.random(),
          duration: moveBaseDuration + 1.0 * Math.random(),
        };
      });

      odlines.data = busLines;
      odlines.timeDuration = timeDuration;
      odlines.playing = true;

      return odlines;
    }

    function drawTip(lat, lng, idx) {
      let pin = window.earth ? earth.sceneTree.$refs["playTip-" + idx] : "";
      let earth = window.window.g_bme3dManager ? window.window.g_bme3dManager.earth : "";
      if (pin) {
        /*let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          bmeConfig.altitude +
          "]";
        let pos1 = eval(pos);
        let pinCzm = pin.czmObject;
        pinCzm.position = pos1;
        let n = idx;

        ctx.$XbsjBase.disposers.push(
          XE.MVVM.track(ctx, "qdWinPos." + n, pinCzm, "winPos")
        );*/
        //XE.MVVM.track(this, "qdWinPos." + n_, pinCzm, "winPos");
      } else {
        let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          bmeConfig.altitude +
          "]";
        let pos1 = eval(pos);
        var tipListObj = {
          ref: "playTip-" + idx,
          czmObject: {
            name: "playTip-" + idx,
            xbsjType: "Pin",
            position: pos1,
            near: 300,
            show: false,
          },
        };
        if (earth && earth.sceneTree) {
          earth.sceneTree.root.children.push(tipListObj);
          let pinCzm = earth.sceneTree.$refs["playTip-" + idx].czmObject;
          let n = idx;

          ctx.$XbsjBase.disposers.push(
            XE.MVVM.track(ctx, "qdWinPos." + n, pinCzm, "winPos")
          );
        }
      }
    }

    function drawPointTip(lat, lng, idx) {
      let pin = window.earth ? earth.sceneTree.$refs["playPos-" + idx] : "";
      let earth = window.window.g_bme3dManager ? window.window.g_bme3dManager.earth : "";
      if (pin) {
        /*let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          bmeConfig.altitude +
          "]";
        let pos1 = eval(pos);
        let pinCzm = pin.czmObject;
        pinCzm.position = pos1;
        let n = idx + ctx.cacheList.length;

        ctx.$XbsjBase.disposers.push(
          XE.MVVM.track(ctx, "qdWinPos." + n, pinCzm, "winPos")
        );*/
        //XE.MVVM.track(this, "qdWinPos." + n_, pinCzm, "winPos");
      } else {
        let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          bmeConfig.altitude +
          "]";
        let pos1 = eval(pos);
        var tipListObj = {
          ref: "playPos-" + idx,
          czmObject: {
            name: "playPos-" + idx,
            xbsjType: "Pin",
            position: pos1,
            near: 300,
            show: false,
          },
        };
        if (earth && earth.sceneTree) {
          earth.sceneTree.root.children.push(tipListObj);
          let pinCzm = earth.sceneTree.$refs["playPos-" + idx].czmObject;
          let n = idx + cacheList.length;

          ctx.$XbsjBase.disposers.push(
            XE.MVVM.track(ctx, "qdWinPos." + n, pinCzm, "winPos")
          );
        }
        //XE.MVVM.track(this, "qdWinPos." + n_, pinCzm, "winPos");
      }
    }

    function drawDustTip(lat, lng, idx) {
      let pin = window.earth ? earth.sceneTree.$refs["dustTip-" + idx] : "";
      let earth = window.window.g_bme3dManager ? window.window.g_bme3dManager.earth : "";
      if (pin) {
        /*let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          bmeConfig.altitude +
          "]";
        let pos1 = eval(pos);
        let pinCzm = pin.czmObject;
        pinCzm.position = pos1;
        let n = idx + cacheList.length + cachePointList.length;

        ctx.$XbsjBase.disposers.push(
          XE.MVVM.track(ctx, "qdWinPos." + n, pinCzm, "winPos")
        );*/
        //XE.MVVM.track(this, "qdWinPos." + n_, pinCzm, "winPos");
      } else {
        let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          bmeConfig.altitude +
          "]";
        let pos1 = eval(pos);
        var tipListObj = {
          ref: "dustTip-" + idx,
          czmObject: {
            name: "dustTip-" + idx,
            xbsjType: "Pin",
            position: pos1,
            near: 300,
            show: false,
          },
        };
        if (earth && earth.sceneTree) {
          earth.sceneTree.root.children.push(tipListObj);
          let pinCzm = earth.sceneTree.$refs["dustTip-" + idx].czmObject;
          let n = idx + cacheList.length + cachePointList.length;

          ctx.$XbsjBase.disposers.push(
            XE.MVVM.track(ctx, "qdWinPos." + n, pinCzm, "winPos")
          );
        }
        //XE.MVVM.track(this, "qdWinPos." + n_, pinCzm, "winPos");
      }
    }

    function delPredictLayers() {
      let buildGroup =
        window.g_bme3dManager?.earth?.sceneTree?.$refs?.qdPredict?.children;
      buildGroup &&
        buildGroup.forEach((item) => {
          item.enabled = false;
          item.destroy();
        });
      buildGroup = [];
    }
    function delDecisionLayers() {
      let buildGroup =
        window.g_bme3dManager?.earth?.sceneTree?.$refs?.qdDecision?.children;
      buildGroup &&
        buildGroup.forEach((item) => {
          item.enabled = false;
          item.destroy();
        });
      buildGroup = [];
    }
    function delLines() {
      if (currentODlineArr.length > 0) {
        currentODlineArr.forEach((item) => {
          item && item.destroy && item.destroy();
        });
      }
      currentODlineArr = [];
    }
    /** */

    /**获取污染预测列表*/
    
    /*for (let i = 0; i < 20; i++) {
      predictList.push({
        time: "4-26 11:90:44",
        name: "TSP A",
        val: "A点位TSP预测出现污染，污染预测值 9mg",
        latitude: 35.630189 + Math.random() * 0.0005,
        longitude: 119.720057 + Math.random() * 0.0005,
      });
    }*/

    
    const turnaroundPages = (timer) => {
      if (timer_predicts.value) {
        clearTimeout(timer_predicts.value);
        timer_predicts.value = null;
      }
      timer_predicts.value = setTimeout(() => {
        currentlayerIndex.value = currentlayerIndex.value + 1;
      }, timer * 1000);
    };

    async function getPredictList() {
      if (!timer_predicts.value) {
        clearTimeout(timer_predicts.value);
        timer_predicts.value = null;
      }
      globalpredicts.length = 0;
      predictList.length = 0;
      let getTspPredictDataList = algorithmType.value
        ? ctx.$apiOpt.getTspPredictDataList
        : ctx.$apiOpt.getTspPredictDataListByLoad;
      let getTspPredictDataListUrl = CONFIG.requestName + getTspPredictDataList;
      let res = await ctx.$apiUtils.get(getTspPredictDataListUrl, {
        customerId: customerId.value,
        threshold: algorithmType.value ? threshold_.value : threshold.value,
      });
      if (res.length > slicenum) {
        entitylayers.value = [];
        let num = Math.ceil(res.length / slicenum);
        for (let i = 0; i < num; i++) {
          if (i < num - 1) {
            entitylayers.value.push({
              label: i * slicenum + 1 + "至" + (i * slicenum + slicenum),
              value: [i * slicenum, i * slicenum + slicenum],
            });
          } else {
            entitylayers.value.push({
              label:
                res.length - i * slicenum == 1
                  ? i * slicenum + 1
                  : i * slicenum + 1 + "至" + res.length,
              value: [i * slicenum, 10000],
            });
          }
        }
      }
      if (predictAnimate && predictAnimate.stop) {
        predictAnimate.stop(true, false);
      }

      ctx.$forceUpdate();
      ctx.$nextTick(() => {
        console.log(res, 'globalpredicts')
        if(res.length) {
          if (res.length > slicenum) {
            Object.assign(globalpredicts, res);
            let start = entitylayers.value[currentlayerIndex.value].value[0];
            let end = entitylayers.value[currentlayerIndex.value].value[1];
            Object.assign(predictList, res.slice(start, end));
            turnaroundPages(Currentlayertimer_long);
          } else {
            Object.assign(globalpredicts, res);
            Object.assign(predictList, res);
          }
        } else {
          globalpredicts = Object.assign(globalpredicts, [])
          console.log(globalpredicts, 'globalpredicts')
        }
      });

      setTimeout(() => {
        if (predictList.length > 0) {
          //predictScroll(predictList.length);
        }

        if (predictList.length >= 0) {
          renderDecision("predict");
        }
      }, 50); //2000
    }
    const predictTimer = ref(null);

    const changePoints = (data, index) => {
      if (timer_predicts.value) {
        clearTimeout(timer_predicts.value);
        timer_predicts.value = null;
      }
      currentlayerIndex.value = index;
      // setTimeout(() => {
      // timer_predicts.value = setTimeout(() => {
      //   currentlayerIndex.value = currentlayerIndex.value + 1;
      //   if (currentlayerIndex.value >= entitylayers.value.length) {
      //     currentlayerIndex.value = 0;
      //   }
      // }, 20 * 1000);
      // }, 5 * 1000);
    };
    // function predictScroll(len) {
    //   if (predictAnimate && predictAnimate.stop) {
    //     predictAnimate.stop(true, false);
    //   }
    //   var $parent = $(ctx.$refs.jsSlideList);
    //   var $first = $parent.find("ul:first");
    //   var height = $first.get(0).offsetHeight;
    //   predictAnimate = $first;

    //   console.log(3000 * len);
    //   //return;
    //   $first.animate(
    //     {
    //       marginTop: -height + "px",
    //     },
    //     3000 * len,
    //     function () {
    //       // 动画结束后，把它插到最后，形成无缝
    //       //$first.css("height", height).appendTo($parent);
    //       $first.css("marginTop", 0).appendTo($parent);
    //       if (predictTimer.value) {
    //         clearTimeout(predictTimer.value);
    //       }
    //       predictTimer.value = setTimeout(() => {
    //         predictScroll(len);
    //       }, 500);
    //     }
    //   );
    // }
    /***/

    /**获取辅助决策列表 */
    

    async function getDecisionList() {
      decisionList.length = 0;
      let getPollutionTraceability = algorithmType.value
        ? ctx.$apiOpt.getPollutionTraceability
        : ctx.$apiOpt.getPollutionTraceabilityByLoad;
      let getPollutionTraceabilityUrl = CONFIG.requestName + getPollutionTraceability;
      let res = await ctx.$apiUtils.get(getPollutionTraceabilityUrl, {
        customerId: customerId.value,
        threshold: algorithmType.value ? threshold_.value : threshold.value,
        upperthreshold: algorithmType.value
          ? upperthreshold_.value
          : upperthreshold.value,
      });
      if (decisionAnimate && decisionAnimate.stop) {
        decisionAnimate.stop(true, false);
      }

      ctx.$forceUpdate();
      ctx.$nextTick(() => {
        console.log(res, 'globalpredicts')
        if(res.length) {
          Object.assign(decisionList, res);
        } else {
          decisionList = Object.assign(decisionList, []);
          console.log(decisionList, 'globalpredicts')
        }
      });

      setTimeout(() => {
        if (decisionList.length > 0) {
          //decisionScroll();
        }
        if (decisionList.length >= 0) {
          renderDecision("decision");
        }
      }, 3000);
    }

    const getTimeFormat = computed(() => {
      // return ''
      return (timeStr) => {
        return new Date(timeStr.replace(/-0/g, "/").replace(/-/g, "/")).Format(
          "hh:mm:ss"
        );
      };
    });

    const optionHover = computed(() => {
      return () => {
        return {
          hoverStop: false, //鼠标悬停关闭
          singleWidth: 0, //单行停顿的宽度（默认值0是无缝不停止的滚动）
          singleHeight: 26, //单行停顿间距（不需要停顿不设置）
          waitTime: 2500, //单行停顿时间（不需要停顿不设置）
          step: 0.5, //向上滚动不停顿
          limitMoveNum: 2, //开始无缝滚动的数据量
          direction: 0, //0向下  1向上   2向左   3向右
          openWatch: false, //开启数据实时监控刷新dom
        };
      };
    });

    const optionHover1 = computed(() => {
      return () => {
        return {
          hoverStop: false, //鼠标悬停关闭
          singleWidth: 0, //单行停顿的宽度（默认值0是无缝不停止的滚动）
          singleHeight: 26, //单行停顿间距（不需要停顿不设置）
          waitTime: 2500, //单行停顿时间（不需要停顿不设置）
          step: 0.5, //向上滚动不停顿
          limitMoveNum: 2, //开始无缝滚动的数据量
          direction: 0, //0向下  1向上   2向左   3向右
          openWatch: false, //开启数据实时监控刷新dom
        };
      };
    });

    const pollutionFlyTimer = ref(null);
    //污染飞跃
    function pollutionFly(
      dataList,
      n
      /*lat,
      lon,
      toLat,
      toLon,
      val,
      toVal,
      deviceNo,
      upperDeviceNo,
      i,
      n*/
    ) {
      if (pollutionFlyTimer.value) {
        clearTimeout(pollutionFlyTimer.value);
      }
      let idx = n ? n : 0;
      if (idx < 20) {
        idx++;
        pollutionFlyTimer.value = setTimeout(() => {
          dataList.forEach((item) => {
            let lat = item.upperDeviceNoLat;
            let lon = item.upperDeviceNoLon;
            let toLat = item.deviceNoLat;
            let toLon = item.deviceNoLon;
            let val = item.value;
            let toVal = item.upperValue;
            let i = item.idx;
            let newLon = lon + ((toLon - lon) * idx) / 20;
            let newLat = lat + ((toLat - lat) * idx) / 20;
            let newVal = val + ((toVal - val) * idx) / 20;
            dustList[i]["data"]["changeValue"] = newVal.toFixed(2);
            drawDustTip(newLat, newLon, i);
          });
          pollutionFly(dataList, idx);
        }, 250);
      } else {
        dataList.forEach((item) => {
          let deviceNo = item.deviceNo;
          let upperDeviceNo = item.upperDeviceNo;
          if ($("#" + deviceNo + "_" + upperDeviceNo).length > 0) {
            $("#" + deviceNo + "_" + upperDeviceNo).removeClass("dustAnimate_");
            $("#" + deviceNo + "_" + upperDeviceNo).removeClass("dustRotate_");
          }
        });

        pollutionFlyTimer.value = setTimeout(() => {
          dataList.forEach((item) => {
            let deviceNo = item.deviceNo;
            let upperDeviceNo = item.upperDeviceNo;

            if ($("#" + deviceNo + "_" + upperDeviceNo).length > 0) {
              $("#" + deviceNo + "_" + upperDeviceNo).addClass("dustAnimate_");
              $("#" + deviceNo + "_" + upperDeviceNo).addClass("dustRotate_");
            }
          });
          pollutionFly(dataList);
        }, 3000);
      }
    }

    function renderDecision(type) {
      if (pollutionFlyTimer.value) {
        clearTimeout(pollutionFlyTimer.value);
      }

      if (ctx.$XbsjBase && ctx.$XbsjBase.destroy) {
        ctx.$XbsjBase.destroy();
      }

      delDecisionLayers();
      delLines();
      cacheList.length = 0;
      cachePointList.length = 0;
      dustList.length = 0;
      qdWinPos.length = 0;
      // console.log(decisionList)
      decisionList.forEach((item, i) => {
        createDecisionLayers(
          item.deviceNoLat,
          item.deviceNoLon,
          item.deviceName,
          item.deviceNo,
          true
        );

        /*createDecisionLayers(
          item.upperDeviceNoLat,
          item.upperDeviceNoLon,
          item.upperName,
          item.upperDeviceNo,
          false
        );*/

        dealODlineData({ lng: item.deviceNoLon, lat: item.deviceNoLat }, [
          {
            lng: item.upperDeviceNoLon,
            lat: item.upperDeviceNoLat,
          },
        ]);
      });

      if (pollutionFlyTimer.value) {
        clearTimeout(pollutionFlyTimer.value);
      }

      decisionList.forEach((item, i) => {
        cacheList.push({
          tipID: "playTip-" + i,
          lng: 0,
          lat: 0,
          type: 0,
          data: {},
        });
        cachePointList.push({
          tipID: "playPos-" + i,
          lng: 0,
          lat: 0,
          type: 0,
          data: item,
        });
        dustList.push({
          tipID: "dustTip-" + i,
          lng: 0,
          lat: 0,
          type: 0,
          data: {},
        });
      });

      decisionList.forEach((item, i) => {
        drawTip(item.upperDeviceNoLat, item.upperDeviceNoLon, i);
      });
      decisionList.forEach((item, i) => {
        drawPointTip(item.upperDeviceNoLat, item.upperDeviceNoLon, i);
      });

      if (pollutionFlyTimer.value) {
        clearTimeout(pollutionFlyTimer.value);
      }

      let needPollutionFlyList = [];
      decisionList.forEach((item, i) => {
        dustList[i]["data"]["deviceName"] = item.deviceName;
        dustList[i]["data"]["value"] = item.value;
        dustList[i]["data"]["deviceNo"] = item.deviceNo;
        dustList[i]["data"]["upperDeviceNo"] = item.upperDeviceNo;
        dustList[i]["data"]["time"] = item.time;
        dustList[i]["data"]["upperName"] = item.upperName;
        dustList[i]["data"]["upperValue"] = item.upperValue;
        dustList[i]["data"]["upperTime"] = item.upperTime;
        //drawDustTip(item.deviceNoLat, item.deviceNoLon, i);
        drawDustTip(item.upperDeviceNoLat, item.upperDeviceNoLon, i);
        needPollutionFlyList.push({
          upperDeviceNoLat: item.upperDeviceNoLat,
          upperDeviceNoLon: item.upperDeviceNoLon,
          deviceNoLat: item.deviceNoLat,
          deviceNoLon: item.deviceNoLon,
          upperValue: item.upperValue,
          value: item.value,
          deviceNo: item.deviceNo,
          upperDeviceNo: item.upperDeviceNo,
          idx: i,
        });
      });
      pollutionFly(needPollutionFlyList);

      //$(".dustReason").addClass("dustTransition");
      if (predictList.length > 0 || decisionList.length > 0) {
        delPredictLayers();
        let idx = 0;
        predictList.forEach((item) => {
          let deviceNo = item.deviceNo;
          let isValid = false;
          for (let n = 0; n < decisionList.length; n++) {
            if (deviceNo === decisionList[n]["deviceNo"]) {
              isValid = true;
            }
          }
          if (!isValid) {
            createPredictLayers(
              item.predict_lat,
              item.predict_lon,
              item.deviceName,
              item.deviceNo,
              true
            );

            dustList.push({
              tipID: "dustTip-" + (idx + decisionList.length),
              lng: 0,
              lat: 0,
              type: 0,
              data: {},
            });
            dustList[idx + decisionList.length]["data"]["deviceName"] = item.deviceName;
            dustList[idx + decisionList.length]["data"]["value"] = item.value;
            dustList[idx + decisionList.length]["data"]["time"] = item.time;
            dustList[idx + decisionList.length]["data"]["type"] = "predict";
            dustList[idx + decisionList.length]["data"]["load"] = item.load;
            if (item.materialUse && item.materialUse.indexOf(";") > -1) {
              let Arr = item.materialUse.split(";");
              let str = "";
              Arr.forEach((t) => {
                str = str + t;
              });
              dustList[idx + decisionList.length]["data"]["materialUse"] = str;
            } else {
              dustList[idx + decisionList.length]["data"]["materialUse"] = "--";
            }
            drawDustTip(item.predict_lat, item.predict_lon, idx + decisionList.length);
            idx++;
          }
        });
        decisionList.forEach((item) => {
          createPredictLayers(
            item.deviceNoLat,
            item.deviceNoLon,
            item.deviceName,
            item.deviceNo,
            true
          );
        });
        // debugger
      } else if (predictList.length === 0 && decisionList.length === 0) {
        delPredictLayers();
      }
    }

    /*for (let i = 0; i < 8; i++) {
      decisionList.push({
        time: "4-26 11:90:44",
        protoName: "TSP A",
        name: "TSP D",
        val: "A点位下一排放源D点位预计5分钟后发生污染，预测污染值 9mg，请及时处理",
        latitude: 35.630189 + Math.random() * 0.0005,
        longitude: 119.720057 + Math.random() * 0.0005,
        protoLatitude: 35.630189 + Math.random() * 0.0005,
        protoLongitude: 119.720057 + Math.random() * 0.0005,
      });
    }*/

    const decisionTimer = ref(null);

    function decisionScroll() {
      if (decisionAnimate && decisionAnimate.stop) {
        decisionAnimate.stop(true, false);
      }
      var $parent = $(ctx.$refs.jsDecisionSlideList);
      var $first = $parent.find("ul:first");
      var height = $first.get(0).offsetHeight;
      decisionAnimate = $first;

      //return;
      $first.animate(
        {
          marginTop: -height + "px",
        },
        6000 * $first.find("li").length,
        function () {
          // 动画结束后，把它插到最后，形成无缝
          $first.css("marginTop", 0).appendTo($parent);
          if (decisionTimer.value) {
            clearTimeout(decisionTimer.value);
          }
          decisionTimer.value = setTimeout(() => {
            decisionScroll();
          }, 500);
        }
      );
    }
    /** */

    function showDustTip() {
      let node = event.currentTarget;
      $(".dustReason").removeClass("opacityShow");
      $(node).find(".dustReason").addClass("opacityShow");
    }

    const renderPlayTimer = ref(null);
    function renderPlay(data) {
      let arr = predictList.filter((item) => {
        return (
          data.predict_lat == item.predict_lat && data.predict_lon == item.predict_lon
        );
      });
      if (arr.length > 0) {
        if (renderPlayTimer.value) {
          clearTimeout(renderPlayTimer.value);
        }
        renderPlayTimer.value = setTimeout(() => {
          flyToQD(data.predict_lon, data.predict_lat, true);
          changeDecisionLayer(data.deviceName, data.deviceNo);
        }, 500);
      } else {
        predictList.push(data);
        renderDecision("predict");
        renderPlay(data);
      }
    }

    flyToQD();

    onMounted(() => {
      let w = $(ctx.$refs.pollutionPrediction).outerWidth();
      let h = $(ctx.$refs.pollutionPrediction).outerHeight();
      ctx.$emit("componentInit", {
        w: w,
        h: h,
        matrixType: matrix.value,
        x: x.value,
        y: y.value,
      });
      //predictScroll();
      //decisionScroll();

      initLayer();

      //initSlider();
    });
    onBeforeUnmount(() => {
      if (predictTimer.value) {
        clearInterval(predictTimer.value);
      }
      if (decisionTimer.value) {
        clearInterval(decisionTimer.value);
      }
      if (flyTimer.value) {
        clearTimeout(flyTimer.value);
      }

      if (drawScenceTimer.value) {
        clearTimeout(drawScenceTimer.value);
      }

      if (ajaxInterVal.value) {
        clearTimeout(ajaxInterVal.value);
      }

      if (renderPlayTimer.value) {
        clearTimeout(renderPlayTimer.value);
      }

      if (initLayerTimer.value) {
        clearTimeout(initLayerTimer.value);
      }

      if (predictAnimate && predictAnimate.stop) {
        predictAnimate.stop(true, false);
      }

      if (decisionAnimate && decisionAnimate.stop) {
        decisionAnimate.stop(true, false);
      }

      if (pollutionFlyTimer.value) {
        clearTimeout(pollutionFlyTimer.value);
      }

      delDecisionLayers();
      delPredictLayers();
      delLines();

      clearObj(cacheList);
      clearObj(cachePointList);
      clearObj(dustList);
      clearObj(qdWinPos);
      cacheList.length = 0;
      cachePointList.length = 0;
      dustList.length = 0;
      qdWinPos.length = 0;

      if (ctx.$XbsjBase && ctx.$XbsjBase.destroy) {
        ctx.$XbsjBase.destroy();
      }
    });

    return {
      predictList,
      decisionList,
      isArcgis,
      cachePointList,
      cacheList,
      dustList,
      qdWinPos,
      prew,
      getTimeFormat,
      optionHover,
      optionHover1,
      showDustTip,
      renderPlay,
      algorithmType,
      algorithmFst,
      algorithmSec,
      entitylayers,
      currentlayerIndex,
      predictListlayer,
      slicenum,
      globalpredicts,
      changePoints,
    };
  },
};
</script>

<style lang="scss">
.algorithmBar {
  .el-switch__label {
    color: #fff;
  }
  .el-switch__label.is-active {
    color: #f4c48f !important;
    font-weight: bolder;
  }
}
</style>
<style lang="scss" scoped="scoped">
.noArcgis {
  opacity: 0;
}

.alarmBar {
  position: absolute;
  top: 100px;
  left: 750px;
}

.algorithmBar {
  position: absolute;
  top: 130px;
  right: 800px;
  pointer-events: all;
  z-index: 99;
  transform: scale(1.6);
  background-color: rgb(64 170 165 / 30%);
  border-radius: 15px;
  padding: 8px 15px 12px 15px;
  box-shadow: 0 0 10px rgb(0 0 0 / 10%);
}
.entitylayers {
  pointer-events: initial;
  position: absolute;
  left: 750px;
  top: 915px;
  width: auto;
  height: 40px;
  font-size: 26px;
  background-color: rgba(64, 170, 165, 0.3);
  border: 1px solid #a3f1ff;
  border-radius: 5px;
  .layercontainer {
    min-width: 250px;
    height: 40px;
    margin: 0 auto;
    float: left;
  }
  .layer_title {
    text-align: center;
    width: 150px;
    height: 40px;
    padding: 0 10px;
    line-height: 40px;
    display: block;
    float: left;
    // border-bottom: 1px solid #8de4f3;
  }
  span {
    width: 16px;
    height: 16px;
    margin-top: 12px;
    outline: none;
    border-radius: 50%;
    background-color: #fff;
    background-color: rgba(255, 255, 255, 0.3);
    text-indent: -999em;
    cursor: pointer;
    margin-right: 10px;
    display: block;
    float: left;
  }
  .data_list {
    background-color: #fff;
    background-color: rgba(255, 255, 255, 0.3);
    text-indent: -999em;
    cursor: pointer;
    // margin-right: 10px;
    display: block;
    float: left;
    // padding-left: 10px;
  }
  .data_list_active {
    // padding-left: 10px;
    color: #99f5ff;
    content: "";
    background-color: #49d9f2;
    box-shadow: 0 0 1px #fff;
    -webkit-transition: height 0.3s ease;
    transition: height 0.3s ease;
  }
}
.alarmContent {
  position: absolute;
  left: 120px;
  top: 20px;
  font-size: 28px;
  width: 200px;
}

.alarmIcon {
  transform: scale(0.7);
  transform-origin: top left;
}

.predictIcon {
  width: 65px;
  height: 40px;
  border: 3px solid greenyellow;
  background: #f5a623;
  position: absolute;
  top: 20px;
  left: 10px;
}

.alarmTag {
  width: 50px;
  position: absolute;
  top: 0px;
  left: 40px;
}

.alarmImg {
  width: 120px;
  transform: rotateX(70deg);
  position: absolute;
  top: 10px;
  left: 10px;
}

.upperName {
  position: absolute;
  top: -60px;
  left: -60px;
  text-align: center;
  width: 200px;
  font-size: 21px;
  display: inline-block;
  word-break: break-all;
  white-space: nowrap;
  color: #fff;
  font-weight: bolder;
  font-size: 22px;
}

.upperValue {
  position: absolute;
  top: -30px;
  left: -60px;
  text-align: center;
  width: 200px;
  font-size: 21px;
  display: inline-block;
  word-break: break-all;
  white-space: nowrap;
  color: #fff;
  font-size: 22px;
}

.dustPredict-brief {
  position: absolute;
  top: -55px;
  left: -60px;
  text-align: center;
  width: 200px;
  font-size: 21px;
  display: inline-block;
  word-break: break-all;
  white-space: nowrap;
}

.dustPredict-load-brief {
  position: absolute;
  top: -115px;
  left: -60px;
  text-align: center;
  width: 200px;
  font-size: 21px;
  display: inline-block;
  word-break: break-all;
  white-space: nowrap;
}

.dustPredict-materialUse-brief {
  position: absolute;
  top: -85px;
  left: -60px;
  text-align: center;
  width: 200px;
  font-size: 21px;
  display: inline-block;
  word-break: break-all;
  white-space: nowrap;
}

.pollutionPrediction {
  width: 600px;
  height: 790px;
  padding-top: 10px !important;
}

.predictBar {
  width: 555px;
  height: 350px;
  top: 50px;
  position: absolute;
}

.predictBar-title {
  position: absolute;
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 28px;
  font-family: "normalFont";
  background: rgba(0, 0, 0, 0.5);
  padding: 0 10px;
}

.predictBar-container {
  width: 100%;
  position: absolute;
  top: 55px;
  bottom: 0px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border: 1px dashed #ccc;
  .slideItem {
    font-size: 24px;
    font-family: "normalFont";
    line-height: 42px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;

    .title {
      color: #f4c48f;
    }

    .content {
      color: #99f5ff;
    }
  }
}

.decisionBar {
  width: 555px;
  height: 350px;
  top: 420px;
  position: absolute;
}

.decisionBar-title {
  position: absolute;
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 28px;
  font-family: "normalFont";
  background: rgba(0, 0, 0, 0.5);
  padding: 0 10px;
}

.decisionBar-container {
  width: 100%;
  position: absolute;
  top: 55px;
  bottom: 0px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border: 1px dashed #ccc;
  .slideItem {
    font-size: 24px;
    font-family: "normalFont";
    line-height: 42px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;

    .title {
      color: #f4c48f;
    }

    .content {
      color: #99f5ff;
    }
  }
}

.processComponent {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  background: radial-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.1));
  z-index: -1;
  //pointer-events: auto;
  overflow: hidden;
  .everyComponent {
    ul {
      width: 100%;
      height: 100%;
      pointer-events: auto;
      .ComponentTip_ {
        background-size: 100% 100%;
        width: 46px;
        height: 46px;
        position: absolute;
        pointer-events: auto;
        img {
          animation: twinkle 1.5s;
          animation-iteration-count: infinite;
          // transform-origin: top center;
          animation-timing-function: linear;
        }
        .green {
          width: 100%;
          position: absolute;
          bottom: 0px;
          position: absolute;
        }
        .red {
          width: 100%;
          position: absolute;
          bottom: 0px;
          position: absolute;
        }
      }
      .DustTip {
        background-size: 100% 100%;
        //background: red;
        width: 50px;
        height: 50px;
        position: absolute;
        img {
          position: absolute;
          width: 50px;
          height: 50px;
        }
      }
      .ComponentTip {
        // background:  url('./img/1.png') no-repeat;
        background-size: 100% 100%;
        //background: red;
        width: 500px;
        height: 320px;
        position: absolute;
        // pointer-events: auto;

        div {
          .img-title {
            width: 100%;
            position: absolute;
            bottom: 150px;
            z-index: 1;
            /*background: url(./img/xk.png) no-repeat left top;
              background: url(./img/sk.png) no-repeat left bottom;*/
          }
          .img2 {
            width: 100%;
            animation: circleScale 1.5s;
            animation-iteration-count: infinite;
            transform-origin: top center;
            animation-timing-function: linear;
            position: absolute;
            bottom: -400px;
            //left: 25%;
          }
          .img-Image {
            width: 100%;
            position: absolute;
            bottom: 100px;
          }
          .img-video {
            width: 100%;
            position: absolute;
            bottom: 100px;
          }
          .warn1 {
            width: 100%;
            position: absolute;
            bottom: 100px;
          }
          .warn2 {
            width: 100%;
            position: absolute;
            bottom: 750px;
          }
          .warn3 {
            width: 100%;
            position: absolute;
            bottom: 700px;
          }
          .green {
            width: 100%;
            transform: scale(0.1);
            position: absolute;
            bottom: -120px;
          }
          .red {
            width: 100%;
            transform: scale(0.1);
            position: absolute;
            bottom: -120px;
          }
        }
      }
    }
  }
}

@keyframes circleScale {
  0% {
    transform: rotateX(105deg) scale(0.1);
  }
  // 50% {
  //   transform: translateY(110px) rotateX(105deg) scale(0.75);
  // }
  100% {
    transform: rotateX(105deg) scale(0.3);
  }
}

@keyframes twinkle {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.slide-container {
  position: absolute;
  top: 0px;
  padding: 10px;
  width: 100%;
}

.dustTransition {
  width: 400px !important;
  height: 300px !important;
}

.dustPredictTransition {
  width: 650px !important;
  height: 330px !important;
}

.algorithmType {
  height: 280px !important;
  width: 400px !important;
  top: -385px !important;
  left: -200px !important;

  .dustReasonInner {
    height: 260px !important;
    width: 400px !important;
  }
}

.dustPredict {
  height: 220px !important;
  width: 400px !important;
  top: -265px !important;
  left: -200px !important;

  .dustReasonInner {
    height: 200px !important;
    width: 400px !important;
  }
}

.opacityShow {
  display: block !important;
}
.dustReason {
  display: none;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -400px;
  left: -320px;
  padding: 0;
  font-size: 22px;
  font-family: "fontNormal";
  transition: all 2s;
  overflow: hidden;
  .dustReasonInner {
    background-image: url("./img/panelView_2_2.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 650px;
    height: 330px;
    padding: 20px 30px;
    position: absolute;
    top: 0px;
    left: 0px;
  }

  .dustReasonTitle {
    font-size: 28px;
    font-family: "bigTitle";
    text-align: center;
    font-weight: bolder;
    margin-bottom: 20px;
  }
}

.dustReasonBlack {
  //background-image: url("./img/panelView_blueBg_2_2.png");
}

.dustRotate {
  filter: blur(0px) opacity(0.8) grayscale(2) invert(0);
}

.dustRotate_ {
  filter: blur(0px) opacity(0.8) invert(0);
}

.dustAnimate {
  animation: dustTwinkle 6s;
  animation-iteration-count: infinite;
  animation-delay: 4s;
  //animation-direction: alternate-reverse;
  // transform-origin: top center;
  animation-timing-function: ease-in-out;
}

.dustAnimate_ {
  animation: dustTwinkle_ 6s;
  animation-iteration-count: infinite;
  animation-delay: 1s;
  // animation-direction: alternate-reverse;
  // transform-origin: top center;
  animation-timing-function: ease-in-out;
}

@keyframes dustTwinkle {
  0% {
    filter: blur(0px) opacity(0.9) grayscale(1) invert(0);
    transform: scale(1.5);
  }
  50% {
    filter: blur(0.25px) opacity(0.9) grayscale(1) invert(0.25);
    transform: scale(1.7);
  }
  90% {
    filter: blur(0.5px) opacity(0.9) grayscale(1) invert(0.5);
    transform: scale(2);
  }
  100% {
    filter: blur(0.5px) opacity(0) grayscale(1) invert(0.5);
    transform: scale(3);
  }
  /*0% {
    filter: blur(0px) opacity(0.9) grayscale(1) invert(0);
    transform: scale(1.5);
  }
  25% {
    filter: blur(0.25px) opacity(0.9) grayscale(1) invert(0.25);
    transform: scale(1.7);
  }
  50% {
    filter: blur(0.5px) opacity(0.9) grayscale(1) invert(0.5);
    transform: scale(2);
  }
  75% {
    filter: blur(0.25px) opacity(0.9) grayscale(1) invert(0.75);
    transform: scale(1.7);
  }
  100% {
    filter: blur(0px) opacity(0.9) grayscale(1) invert(1);
    transform: scale(1.5);
  }*/
}

@keyframes dustTwinkle_ {
  0% {
    filter: blur(0px) opacity(0.9) invert(0);
    transform: scale(1.5);
  }
  50% {
    filter: blur(0.25px) opacity(0.9) invert(0.25);
    transform: scale(1.7);
  }
  90% {
    filter: blur(0.5px) opacity(0.9) invert(0.25);
    transform: scale(3);
  }
  100% {
    filter: blur(0.5px) opacity(0.3) invert(0.25);
    transform: scale(4);
  }
}

.red {
  color: #f5a623;
  font-weight: bolder;
}
.green {
  color: #4fc5ff;
}
.blue {
  color: #8de4f3;
}
.grey {
  color: #94a2b0;
  margin-bottom: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
